import React, { useState, useRef } from 'react'
import { Link } from 'react-router-dom';

const Profile = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [profileImage, setProfileImage] = useState("images/avatars/avatar-3.png");
    const fileInputRef = useRef(null);

    // Refs for view mode elements
    const emailRef = useRef(null);
    const phoneRef = useRef(null);
    const cityRef = useRef(null);
    const countryRef = useRef(null);
    const complexNameRef = useRef(null);

    const handleEditToggle = () => {
        if (isEditing) {
            // Get current values from inputs
            const emailInput = document.querySelector('input[name="email"]');
            const phoneInput = document.querySelector('input[name="phone"]');
            const cityInput = document.querySelector('input[name="city"]');
            const countryInput = document.querySelector('input[name="country"]');
            const complexNameInput = document.querySelector('input[name="complexName"]');
            
            // Update view mode elements using refs
            if (emailInput && emailRef.current) emailRef.current.textContent = emailInput.value;
            if (phoneInput && phoneRef.current) phoneRef.current.textContent = phoneInput.value;
            if (cityInput && cityRef.current) cityRef.current.textContent = cityInput.value;
            if (countryInput && countryRef.current) countryRef.current.textContent = countryInput.value;
            if (complexNameInput && complexNameRef.current) complexNameRef.current.textContent = complexNameInput.value;
            
            console.log("Profile updated successfully!");
            alert('Profile updated successfully!');
        }
        setIsEditing(!isEditing);
    };

    const handleCancel = () => {
        // Reset input values to original
        const emailInput = document.querySelector('input[name="email"]');
        const phoneInput = document.querySelector('input[name="phone"]');
        const cityInput = document.querySelector('input[name="city"]');
        const countryInput = document.querySelector('input[name="country"]');
        const complexNameInput = document.querySelector('input[name="complexName"]');
        
        if (emailInput) emailInput.value = "john@complex.com";
        if (phoneInput) phoneInput.value = "+1 555 0001";
        if (cityInput) cityInput.value = "New York";
        if (countryInput) countryInput.value = "United States";
        if (complexNameInput) complexNameInput.value = "City Sporting Complex";
        
        setIsEditing(false);
    };

    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const imageURL = URL.createObjectURL(file);
            setProfileImage(imageURL);
        }
    };

    return (
        <div className="page-wrapper">
            <div className="page-content">
                <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                    <div className="breadcrumb-title pe-3">Profile</div>
                    <div className="ps-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0 p-0">
                                <li className="breadcrumb-item">
                                    <Link to="/"><i className="bx bx-home-alt" /></Link>
                                </li>
                                <li className="breadcrumb-item active">Profile</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div className='mt-5'>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <div className="d-flex align-items-center gap-3">
                            <div 
                                className="profile-avatar" 
                                id="avatarInitials"
                                style={{ cursor: 'pointer' }}
                                onClick={handleImageClick}
                            >
                                JD
                            </div>
                            <input 
                                type="file" 
                                ref={fileInputRef} 
                                style={{ display: 'none' }} 
                                accept="image/*"
                                onChange={handleImageChange}
                            />
                            <div>
                                <h4 className="mb-0 fw-bold">John Davis</h4>
                                <span className="text-success">Complex Owner</span>
                            </div>
                        </div>
                        <button 
                            className="btn btn-success px-4" 
                            id="editBtn"
                            onClick={handleEditToggle}
                        >
                            {isEditing ? 'Save Changes' : 'Edit Profile'}
                        </button>
                    </div>

                    <div className="card shadow-sm border-0 rounded-4 p-4">
                        <div className="row g-4">
                            {/* Email */}
                            <div className="col-md-6">
                                <label className="profile-label">Email Address</label>
                                {!isEditing ? (
                                    <p className="view-mode" ref={emailRef}>john@complex.com</p>
                                ) : (
                                    <input 
                                        type="email" 
                                        className="form-control edit-mode" 
                                        name="email"
                                        defaultValue="john@complex.com"
                                    />
                                )}
                            </div>
                            {/* Phone */}
                            <div className="col-md-6">
                                <label className="profile-label">Phone Number</label>
                                {!isEditing ? (
                                    <p className="view-mode" ref={phoneRef}>+1 555 0001</p>
                                ) : (
                                    <input 
                                        type="text" 
                                        className="form-control edit-mode" 
                                        name="phone"
                                        defaultValue="+1 555 0001"
                                    />
                                )}
                            </div>
                            {/* City */}
                            <div className="col-md-6">
                                <label className="profile-label">City</label>
                                {!isEditing ? (
                                    <p className="view-mode" ref={cityRef}>New York</p>
                                ) : (
                                    <input 
                                        type="text" 
                                        className="form-control edit-mode" 
                                        name="city"
                                        defaultValue="New York"
                                    />
                                )}
                            </div>
                            {/* Country */}
                            <div className="col-md-6">
                                <label className="profile-label">Country</label>
                                {!isEditing ? (
                                    <p className="view-mode" ref={countryRef}>United States</p>
                                ) : (
                                    <input 
                                        type="text" 
                                        className="form-control edit-mode" 
                                        name="country"
                                        defaultValue="United States"
                                    />
                                )}
                            </div>
                            {/* Complex Name */}
                            <div className="col-md-6">
                                <label className="profile-label">Complex Name</label>
                                {!isEditing ? (
                                    <p className="view-mode" ref={complexNameRef}>City Sporting Complex</p>
                                ) : (
                                    <input 
                                        type="text" 
                                        className="form-control edit-mode" 
                                        name="complexName"
                                        defaultValue="City Sporting Complex"
                                    />
                                )}
                            </div>
                            {/* Subscription */}
                            <div className="col-md-6">
                                <label className="profile-label">Subscription Plan</label>
                                <div className="view-mode">
                                    <span className="badge bg-success-subtle text-success px-3 py-2 rounded-pill">
                                        ● Pro Plan — Active
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                        {/* Save Section - only show in edit mode */}
                        {isEditing && (
                            <div className="mt-4" id="saveSection">
                                <button className="btn btn-success px-4" onClick={handleEditToggle}>
                                    Save Changes
                                </button>
                                <button className="btn btn-outline-secondary ms-2" onClick={handleCancel}>
                                    Cancel
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Profile